export default __webpack_public_path__ + "static/media/public.ac8b224a.jpg";